function changeBackgroundColor(element) {
  if (element.classList.contains('selected')){
    return;
  }
 var priorSelection = document.getElementsByClassName('selected');
   for (let slection of priorSelection) {
     slection.classList.remove('selected')
   }
 element.classList.add('selected')
 var selectedColors = document.getElementsByClassName(element.innerText);
 var colors = document.getElementsByClassName('colorswatch ');
 var colorSelectText = document.getElementById('colorSelect');
  colorSelectText.classList.remove('hidden')
  for (let color of colors) {
    color.classList.add('hidden')
  }
  for (let color of selectedColors) {
    color.classList.remove('hidden')
  }
   var sizes = document.getElementsByClassName('sizeSwatchs');
  for (let size of sizes) {
    size.classList.add('hidden')
  }
}



function getSizes(element) {
    if (element.classList.contains('selected')){
    return;
  }
 var priorSelection = element.parentElement.getElementsByClassName('selected');
  
   for (let slection of priorSelection) {
     slection.classList.remove('selected')
   }
   element.classList.add('selected') 
 var selectedColors = document.getElementsByClassName(element.id);
 var colors = document.getElementsByClassName('sizeSwatchs');
  for (let color of colors) {
    color.classList.add('hidden')
    color.classList.remove('selected')
    var selectedSize = color.getElementsByClassName('sizeSwatch');
     for (let color of selectedSize) {
    color.classList.remove('selected')
  }
  }
  for (let color of selectedColors) {
    color.classList.remove('hidden')
  }
   var selectedColorDiv = document.getElementById('colorSelection');
   var selectedColor = element.id.split('-')
  selectedColorDiv.innerText = selectedColor[1]
}

function previewStyle(url) {
  document.getElementsByClassName("image-magnify-lightbox")[0].srcset=url;
}

function removePreview(url) {
  document.getElementsByClassName("image-magnify-lightbox")[0].srcset=url;
}

function selectSize(element) {
  if (element.classList.contains('selected')){
    return;
  }
 var priorSelection = element.parentElement.getElementsByClassName('selected');
   for (let slection of priorSelection) {
     slection.classList.remove('selected')
   }

 
 element.classList.add('selected')
}



class quantityNametag extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value);
  }
}

class addToCart extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

       this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
            
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = []
      console.log(this)
      if (this.cart) {

          this.cart.setActiveElement(document.activeElement);

          const ShirtNameElement = document.getElementById("garments").getElementsByClassName("selected");
          const ColorNameElement = document.getElementById("colors").getElementsByClassName("selected");
          const SizeNameElement = document.getElementById("sizes").getElementsByClassName("selected");
          console.log(ShirtNameElement)
          console.log(ColorNameElement)
          console.log(SizeNameElement)
          var ShirtName = ""
          var ColorName = ""
          var SizeName = ""

        if (ShirtNameElement.length > 0 && ColorNameElement.length > 0 && SizeNameElement.length > 0 ) {
          console.log(ShirtNameElement)
          console.log(ColorNameElement)
          console.log(SizeNameElement)
          var ShirtName = ShirtNameElement[0].innerText;
          var ColorName = ColorNameElement[0].id.split('-')[1];
          var SizeName =SizeNameElement[0].innerText;
          console.log(ShirtName)
          console.log(ColorName)
          console.log(SizeName)
        } else{
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            confirm("Please complete your selection before adding this item to cart");
             return
        }
        
          const ShirtID = document.getElementById("sizes").getElementsByClassName("selected")[0].id;
          var quantity = document.getElementsByName("quantity")[0].value;
          var properties = "Shirt: " + ShirtName + " Color: "+ ColorName  +" Size: ";
        
          var id = document.getElementById("addProduct").getAttribute('value');
          console.log(id)
        
          var shirtJSON ={'Style':ShirtName,'Color':ColorName,'Size': SizeName, 'Code': ShirtID}

          //with string built out, add it to itemJSON
         var item = {
            "id": parseInt(id),
            "quantity": parseInt(quantity),
            "properties": shirtJSON
          }
          formData.push(item); 
      }
      
      config.body = JSON.stringify({'items': formData, 'sections': ["cart-icon-bubble", "cart-drawer"]})
      console.log(config)
      fetch(window.origin + '/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: (config.body),
                    
        
                      })
        .then((response) => response.json())
        .then((response) => {
          console.log("response: ",response)
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);   
            }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
                   document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      if (this.header) this.header.reveal();
     
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },{
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.shopify-section',
      }
    ];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('submit-emb', addToCart);
customElements.define('quantity-input-nametags', quantityNametag);